class ProductDimensions extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initComponent();
  }

  initComponent() {
    console.log("INIT COMPONENT");
    this.Selectors = {
      actionBtn: "#product-dimensions-btn",
      modal: "#dimensionModal",
      closeBtn: "#dimensionModal__close-btn",
    };
    this.viewButton = this.querySelector(this.Selectors.actionBtn);
    this.modal = this.querySelector(this.Selectors.modal);
    this.closeButton = this.querySelector(this.Selectors.closeBtn);

    if (this.viewButton && this.modal && this.closeButton) {
      this.viewButton.addEventListener("click", (event) => {
        event.preventDefault();
        this.modal.classList.remove("hidden");
        document.querySelector("body").classList.add("overflow-hidden");
      });

      this.closeButton.addEventListener("click", () => {
        this.modal.classList.add("hidden");
        document.querySelector("body").classList.remove("overflow-hidden");
      });

      window.addEventListener("click", (event) => {
        if (event.target === this.modal) {
          this.modal.classList.add("hidden");
          document.querySelector("body").classList.remove("overflow-hidden");
        }
      });
    } else {
      document.querySelector("body").classList.remove("overflow-hidden");
    }
  }
}

customElements.define("product-dimensions", ProductDimensions);
